var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "circle_svg__Layer_1",
    width: "inherit",
    height: "inherit",
    "data-name": "Layer 1",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".circle_svg__cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.65 301.45H93.74c0-112.62 91.29-203.91 203.91-203.91h0zM297.65 301.45v203.91c-112.62 0-203.91-91.29-203.91-203.91zM297.65 301.45h203.91c0 112.62-91.29 203.91-203.91 203.91h0z",
    className: "circle_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.12 252.93V85.26c0-6.33 5.3-11.42 11.61-11.04 95.75 5.77 172.38 82.4 178.15 178.15.38 6.31-4.72 11.61-11.04 11.61H346.17c-6.11 0-11.06-4.95-11.06-11.06Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgCircle;